<template>
    <Drawer v-model:visible="showDrawer" position="right" classes="!w-[45%] !bg-[#F0F0F0] chat-drawer">
        <ThreadChat
            :ticket_id="loadticket"
            :thread_route="thread_route"
            :risposta_rapida_route="risposta_rapida_route"
            :allow_reply="permetti_risposta_rapida ?? 1"
            :ruolo="ruolo"/>
    </Drawer>
    <div class="flex justify-between" v-if="route_filtri">
        <Card v-for="f in filtri" @click="filterTickets(f.nome, $event)" class=" cursor-pointer filter-card"
              :class="f.label.toLowerCase().split(' ').join('_')">
            <template #title>
                {{ f.label }}
            </template>
            <template #content>
                {{ contatori[f.nome] }}
            </template>
        </Card>
    </div>


    <Card v-if="selected.length > 0" id="edit-ticket-multiplo-card">
        <template #content>

            <div class="flex  gap-3" @click.stop="" id="edit-multiplo-container">
                <div class="flex justify-between general-info-actions">
                    <div id="element-count">
                        {{ selected.length }} {{
                            selected.length == 1 ? 'elemento selezionato' : 'elementi selezionati'
                        }}
                    </div>
                    <div class="flex multi-action">
                        <a @click="selected.length > 1 && !selectedHaveApiTicket ? unisci_ticket() : null"
                           :class="selected.length > 1 && !selectedHaveApiTicket ? '' : 'pointer-events-none opacity-50'">
                            <!-- <i class="pi pi-arrow-down-left-and-arrow-up-right-to-center"></i> -->
                            <img src="/img-appalto/mergeicon.svg"/>
                        </a>
                        <a @click="elimina_multiplo">
                            <i class="pi pi-trash text-red-500 cursor-pointer"></i>
                        </a>
                    </div>
                </div>
                <div class="">
                    <FloatLabel class="w-full" variant="on">
                        <Select v-model="ticketingtipo_id" :options="formStructure['ticketingtipo_id'][3]"
                                name="ticketingtipo_id" optionLabel="nome" optionValue="id"
                                class="w-full" :invalid="errors !== undefined && key in errors"
                                @change="(event)=> onChangeSelect(event,key)"/>
                        <label for="ticketingtipo_id">{{ this.$root.trans.ticket_tipologia }} </label>
                    </FloatLabel>
                </div>
                <div class="">
                    <FloatLabel class="w-full" variant="on">
                        <MultiSelect v-model="ticketingutentiteam_id" display="chip" name="ticketingutentiteam_id"
                                     :options="formStructure['ticketingutentiteam_id'][3]" optionLabel="nome"
                                     optionValue="id" filter class="w-full"
                                     :invalid="errors !== undefined && key in errors"
                                     @change="(event)=>onSelectDipenedenteChange(event,key)"/>
                        <label>{{ this.$root.trans.ticket_assegna }}</label>
                    </FloatLabel>
                </div>

                <div>
                    <button class="p-button p-component p-button-success" @click="assegna_multiplo">
                        <span class="p-button-label">Salva</span>
                    </button>
                </div>

            </div>
        </template>

    </Card>
    <Card ref="tableCard" class="ticketing-table-card">
        <template #content>
            <DataTable v-model:filters="filters"
                       class="app-datatable"
                       :filterButtonProps="{ filter: { class: 'app-dt-filter-btn' } }"
                       v-model:editingRows="editingRows"
                       :value="rows"
                       size="small"
                       filterDisplay="menu"
                       tableClass="ticketing-datatable"
                       loadingIcon="pi pi-spin pi-spinner"
                       removableSort
                       stripedRows
                       scrollable
                       :scrollHeight="tableScrollHeight"
                       :loading="loading"
                       :lazy="is_lazy"
                       :totalRecords="total"
                       @page="pageChange"
                       ref="dt"
                       stateStorage="session" :stateKey="stateKey"
                       :globalFilterFields="[
              'titolo',
              'numero_ticket',
              'utente',
              ...retrieveFiltri()

              ]"
                       :pt="{
                table: { style: 'min-width: 50rem' },
                column: {
                    bodycell: ({ state }) => ({
                        style:  state['d_editing']&&'padding-top: 0.75rem; padding-bottom: 0.75rem'
                    })
                }
            }">
                <template #header>
                    <div class="flex justify-between container-button-e-search">
                        <div class="icon-action-datatable-container">
                            <Button class="icon-action-datatable" text icon="pi pi-filter-slash"
                                    @click="clearFilter()"/>
                            <Button v-if="add_action" as="a" class="icon-action-datatable" text icon="pi pi-plus" :href="add_action"/>
                            <menu-strumenti :datatable_id=datatable_id
                                            :current_route=current_route
                                            :current_params=current_params></menu-strumenti>
                        </div>
                        <IconField class="ricerca-search">
                            <InputText v-model="searchQuery" @keyup.enter="onSearchInput" :placeholder="$root.trans.cerca"
                                       class="input-cerca"/>
                            <InputIcon>
                                <i :class="searchLoading ? 'pi pi-spin pi-spinner' : 'pi pi-search'" @click="onSearchInput" style="cursor:pointer"/>
                            </InputIcon>
                        </IconField>
                    </div>
                </template>
                <template #empty> {{ mess_vuoto }}</template>
                <template v-if="Object.keys(actions).length > 0">
                    <Column :exportable="false" :pt="{ headerCell: { class: 'w-[80px] min-w-[80px] max-w-[80px]' }, bodyCell: { class: 'w-[80px] min-w-[80px] max-w-[80px]' } }">
                        <template #body="slotProps">
                            <div class="flex gap-[4px]">

                                <template v-if="selectable">
                                    <div class="flex items-center">
                                        <Checkbox v-model="selected" :value="slotProps.data.id"
                                                  :name="slotProps.data.id.toString()"/>
                                    </div>
                                </template>
                                <div @click="loadThreadDrawer(slotProps.data)"
                                     class="flex items-center justify-center cursor-pointer mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text">
                                    <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center"></i>
                                </div>
                                <template v-if="!slotProps.data.use_fallback_action">
                                    <template v-for="(action, key) in actions">
                                        <template
                                            v-if="!['aggiorna' , 'elimina','componente','fallback'].includes(key)">
                                            <a :href="generateUrl(action, slotProps.data)"
                                               class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                                                <i :class="'pi '+action.icona"></i>
                                            </a>
                                        </template>
                                        <template v-if="key === 'elimina'">
                                            <a @click="rimuoviRiga(action , slotProps.data )"
                                               class="mx-1 p-button  p-button-icon-only p-button-secondary p-button-rounded p-button-text  ">
                                                <i :class="'pi '+action.icona"></i>
                                            </a>
                                        </template>
                                        <template v-if="key === 'componente'">
                                            <component
                                                :is="component(action.componente)"
                                                v-bind="actionComponentProps({...slotProps.data, ...action.componente.props})"
                                            />
                                        </template>
                                    </template>
                                </template>
                                <template v-else>
                <span class="mx-1 p-button p-button-icon-only p-button-secondary p-button-rounded p-button-text"
                      v-tooltip="actions['fallback'].message">
                  <i :class="'text-yellow-600 pi '+actions['fallback'].icona"></i>
                </span>
                                </template>
                            </div>
                        </template>
                    </Column>
                </template>
                <Column v-for="column of columns"
                        :field="column.name"
                        :header="column.title"
                        sortable
                        :filter="column.filtro !== false"
                        filterMarchMode="custom"
                        :showFilterMatchModes="column.formato !== 'componenti' && !['assegnatari','stato','priorita'].includes(column.name)"
                        :showFilterOperator="column.formato !== 'componenti' && !['assegnatari','stato','priorita'].includes(column.name)"
                        :pt="getColumnPT(column.name, column.title)">
                    <template #sorticon="slotProps">
                        <span
                            :class="['app-dt-icon', slotProps.sorted ? (slotProps.sortOrder === 1 ? 'pi pi-sort-amount-up-alt' : 'pi pi-sort-amount-down-alt') : 'pi pi-sort-alt']"></span>
                    </template>
                    <template #filtericon>
                        <span class="pi pi-filter app-dt-icon"></span>
                    </template>
                    <template #editor="{ data, field }">
                        <template v-if="column.formato === 'select' ">
                            <Select v-model="data[field]" :options="data['options_'+field] ?? column.options"
                                    optionLabel="nome" optionValue="id"
                                    placeholder="Select a Status" fluid
                                    :disabled="column.disabled || !data[column.conditional_enabled]">
                                <template #option="slotProps">
                                    <div> {{ slotProps.option.nome }}</div>
                                </template>
                            </Select>
                        </template>
                        <template v-else>
                            <InputText v-model="data[field]" fluid :disabled="column.disabled"/>
                        </template>
                    </template>
                    <template #body="{data}">
        <span :class="!data['visualizzato'] && apply_visualizzati ? 'font-black' : 'font-thin'">

          <template v-if="column.formato === 'data'">
            {{ data[column.name] != '' && data[column.name] != null ? formatDate(data[column.name]) : '' }}
          </template>
          <template v-else-if="column.formato === 'dataora'">
            {{ data[column.name] != '' && data[column.name] != null ? formatDateTime(data[column.name]) : '' }}
          </template>
          <template v-else-if="column.formato === 'ora'">
            {{ formatTime(data[column.name]) }}
          </template>
          <template v-else-if="column.formato === 'num_intero'">
            {{ formatNumberInt(data[column.name]) }}
          </template>
          <template v-else-if="column.formato === 'num_decimale'">
            {{ formatNumberDecimal(data[column.name]) }}
          </template>
          <template v-else-if="column.formato === 'prezzo'">
            {{ formatCurrency(data[column.name]) }}
          </template>
          <template v-else-if="column.formato === 'colore'">
            <span v-html="formatColor(data[column.name])"></span>
          </template>
          <template v-else-if="column.formato === 'select'">
            {{ formatSelectId(data, column) }}
          </template>
          <template v-else-if="column.formato === 'componenti'">
            <template v-for="componente in data[column.name]">
              <component
                  v-if="componente?.component"
                  :is="component(componente)"
                  v-bind="componentProps(componente)"
              />
            </template>
          </template>
          <template v-else-if="column.formato === 'html'">
            <span v-html="column.name === 'sla' ? formatSlaHtml(data[column.name]) : DOMPurify.sanitize(data[column.name])"></span>
          </template>
          <template v-else>
            <span
                :class="['numero_ticket','titolo'].includes(column.name) ? 'cursor-pointer underline' : ''"
                @click="['numero_ticket','titolo'].includes(column.name) ? rowClicked(data['id']) : null"
            >{{ data[column.name] }}</span>
          </template>
        </span>
                    </template>
                    <template #filter="{ filterModel, filterCallback }">
                        <template v-if="column.formato === 'data'">
                            <DatePicker v-model="filterModel.value" dateFormat="yyyy/mm/dd" placeholder="mm/dd/yyyy"/>
                        </template>
                        <template v-else-if="column.formato === 'dataora'">
                            <DatePicker v-model="filterModel.value" dateFormat="yyyy/mm/dd hh:mm"
                                        placeholder="mm/dd/yyyy hh:mm" showTime
                                        hourFormat="24"/>
                        </template>
                        <template v-else-if="column.formato === 'ora'">
                            <DatePicker v-model="filterModel.value" dateFormat="hh:mm" placeholder="hh:mm" timeOnly
                                        hourFormat="24"/>
                        </template>
                        <template v-else-if="column.formato === 'colore'">
                            <ColorPicker v-model="filterModel.value"/>
                        </template>
                        <template v-else-if="column.formato === 'componenti'">
                            <Select :options="filtri_datatable[column.name]" v-model="filterModel.value"
                                    :placeholder="$root.trans.option_selezionare"/>
                        </template>
                        <template v-else>
                            <InputText v-model="filterModel.value" type="text" :placeholder="column.title"/>
                        </template>
                    </template>
                </Column>
                <template #footer>
                    <div v-if="is_lazy && loadingMore" class="flex justify-center p-3">
                        <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i>
                    </div>
                    <div v-if="allLoaded && rows.length > 0" class="flex justify-center items-center" style="height: 60px;">
                        <span class="text-gray-500">Fine elenco n.ticket {{ rows.length }}</span>
                    </div>
                </template>
            </DataTable>

        </template>
    </Card>
</template>

<script>
import DOMPurify from 'dompurify';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputNumber from 'primevue/inputnumber';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import Button from 'primevue/button';
import DatePicker from 'primevue/datepicker';
import ColorPicker from 'primevue/colorpicker';
import {FilterMatchMode, FilterOperator, FilterService} from '@primevue/core/api';
import Select from 'primevue/select';
import {resolveComponent} from 'vue';
import {toRaw} from 'vue';

import Tag from 'primevue/tag';
import Checkbox from 'primevue/checkbox';
import SingleForm from './SingleForm.vue'
import FloatLabel from 'primevue/floatlabel';
import MultiSelect from 'primevue/multiselect';
import Drawer from './Drawer.vue';
import ThreadChat from './ThreadChat.vue';
import Card from 'primevue/card';

FilterService.register('componentFilter', (value, filter) => {
    if (!filter || filter.trim() === '') return true;
    if (!Array.isArray(value)) return false;

    const needle = filter.toLowerCase();

    return value.some(a => {
        const nome = a?.nome_stringa || "";
        return nome.toLowerCase().includes(needle);
    });
});

export default {
    name: "DatatableTicketing",
    props: ['modulo',
        'colonne',
        'route_righe',
        'azioni',
        'add_action',
        'mess_vuoto',
        'mess_caricamento',
        'filtri_custom',
        'route_params',
        'dati',
        'struttura',
        'azione',
        'selectable',
        'dettaglio',
        'azione_unione',
        'applica_visualizzati',
        'route_filtri',
        'is_lazy',
        'thread_route',
        'risposta_rapida_route',
        'permetti_risposta_rapida',
        'categorie_ticket',
        'datatable_id',
        'current_route',
        'current_params',
        'ruolo'
    ],
    components: {
        Card,
        DataTable,
        Column,
        InputNumber,
        InputText,
        InputIcon,
        IconField,
        Button,
        DatePicker,
        ColorPicker,
        Select,
        Tag,
        Checkbox,
        SingleForm,
        FloatLabel,
        MultiSelect,
        Drawer,
        ThreadChat
    },
    data() {
        return {
            filters: {
                global: {value: null, matchMode: FilterMatchMode.CONTAINS}
            },
            loading: true,
            rows: [],
            // se ho fatto json_encode in php non serve json parse , vue lo interpreta già come un oggetto
            columns: this.colonne,
            actions: this.azioni,
            globalfilters: [],
            editingRows: [],
            customFilters: this.filtri_custom,
            datatable_id: this.datatable_id || null,
            current_route: this.current_route || null,
            current_params: this.current_params || null,
            selectable: this.selectable ?? false,
            selected: [],
            ticketingtipo_id: 0,
            allUser: [],
            allTipi: [],
            ticketingutentiteam_id: [],
            formStructure: this.struttura ? JSON.parse(this.struttura) : null,
            apply_visualizzati: this.applica_visualizzati ?? true,
            contatori: [],
            filtrato: false,
            filtroScelto: null,
            showDrawer: false,
            loadticket: null,
            filtri: [
                {
                    nome: 'nuovi',
                    label: "Nuovi"
                },
                {
                    nome: 'assegnati_a_me',
                    label: "Assegnati a me"
                },
                {
                    nome: 'scaduti',
                    label: "Scaduti"
                },
                {
                    nome: 'non_assegnati',
                    label: "Non assegnati"
                },
                {
                    nome: 'assegnati_a_team',
                    label: "Assegnati al mio team"
                },
                {
                    nome: 'in_scadenza',
                    label: "In scadenza"
                }
            ],
            filtri_datatable: {
                assegnatari: [],
                stato: [],
                priorita: []
            },
            categorie: [],
            filtro_categoria: null,
            //edit paginator
            total: 0,
            //end edit paginator
            // infinite scroll
            currentPage: 1,
            loadingMore: false,
            allLoaded: false,
            tableOffsetTop: 0,
            headerHeight: 0,
            resizeObserver: null,
            _scrollContainer: null,
            searchQuery: '',
            searchLoading: false,
            searchTimer: null,
        }
    },
    computed: {
        stateKey() {
            const modulo = this.modulo || route().current();
            return `${modulo}-session`;
        },
        tableScrollHeight() {
            const margin = 0;
            return `calc(100vh - ${this.tableOffsetTop + this.headerHeight + margin}px)`;
        },
        selectedHaveApiTicket() {
            return this.rows.some(row => this.selected.includes(row.id) && row.chiama_api && row.url_base_api);
        },
    },
    async created() {
        const prefix = this.ruolo == 'admin' ? '' : this.ruolo + '/';
        axios.get(route(prefix + 'ticketing/filtri')).then((res) => {
            if (res.data) {
                this.filtri_datatable = res.data
            }
        }).catch((err) => {
            console.log(err)
        })
        this.initFilters();
        if (this.selectable) {
            this.allUser = [...this.formStructure['ticketingutentiteam_id'][3]];
            this.allTipi = [...this.formStructure['ticketingtipo_id'][3]];
        }
        const categorie_ticket = this.categorie_ticket || '[]';
        this.categorie = [...JSON.parse(categorie_ticket)];

        this.globalfilters = this.columns.map(column => {
            if (column.filtro) return column.name
        });
        this.globalfilters = [...this.globalfilters, ...this.customFilters];

        // Caricamento iniziale righe (spostato da beforeCreate dove i metodi non sono disponibili)
        this.loading = true;
        this.currentPage = 1;
        this.allLoaded = false;
        const righe = await axios.get(route(this.route_righe, this.buildRouteParams()));
        if (righe.status === 200) {
            this.rows = righe.data.ticket ?? righe.data;
            this.contatori = righe.data.contatori;
            if (this.is_lazy) {
                this.total = righe.data.total ?? 0;
                const loaded = this.rows?.length ?? 0;
                if (loaded >= this.total) {
                    this.allLoaded = true;
                }
            } else {
                this.allLoaded = true;
            }
            this.loading = false;
        } else {
            this.rows = [];
            this.loading = false;
        }
    },
    async mounted() {
        window.filtriDatatable();
        this.clearFilter();
        //this.loading = false;

        // Calcola l'altezza dinamica della tabella
        this.calculateTableOffset();

        // Osserva i cambiamenti di dimensione
        this.resizeObserver = new ResizeObserver(() => {
            this.calculateTableOffset();
        });

        // Osserva il parent della tabella per rilevare cambiamenti
        if (this.$refs.tableCard?.$el?.parentElement) {
            this.resizeObserver.observe(this.$refs.tableCard.$el.parentElement);
        }

        // Ascolta anche il resize della finestra
        window.addEventListener('resize', this.calculateTableOffset);

        // Infinite scroll: listener sullo scroll container della DataTable
        this.$nextTick(() => {
            this.setupInfiniteScroll();
        });
    },
    beforeUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        window.removeEventListener('resize', this.calculateTableOffset);
        if (this._scrollContainer) {
            this._scrollContainer.removeEventListener('scroll', this.onTableScroll);
        }
    },
    watch: {
        // Auto-fill: se dopo il caricamento le righe non riempiono il container, carica la pagina successiva
        rows() {
            this.$nextTick(() => {
                this.setupInfiniteScroll();
                if (!this.is_lazy || !this._scrollContainer || this.allLoaded) return;
                if (this._scrollContainer && this._scrollContainer.scrollHeight <= this._scrollContainer.clientHeight) {
                    this.loadMore();
                }
            });
        },
    },
    methods: {
        buildRouteParams(extra = {}) {
            return {
                ...(this.route_params ?? {}),
                ...extra,
            };
        },
        setupInfiniteScroll() {
            if (!this.is_lazy) return;
            const scrollContainer = this.$refs.dt?.$el?.querySelector('.p-datatable-table-container');
            if (!scrollContainer) return;

            if (this._scrollContainer && this._scrollContainer !== scrollContainer) {
                this._scrollContainer.removeEventListener('scroll', this.onTableScroll);
            }

            if (this._scrollContainer !== scrollContainer) {
                this._scrollContainer = scrollContainer;
                this._scrollContainer.addEventListener('scroll', this.onTableScroll);
            }
        },
        async loadRows() {
            this.loading = true;
            const righe = await axios.get(route(this.route_righe, this.buildRouteParams()));
            if (righe.status === 200) {
                this.rows = righe.data.ticket ?? righe.data;
                this.contatori = righe.data.contatori;
                if (this.is_lazy && righe.data.total) {
                    this.total = righe.data.total ?? 0;
                }
                if (this.is_lazy) {
                    this.currentPage = 1;
                    this.allLoaded = (this.rows?.length ?? 0) >= this.total;
                }
            } else {
                this.rows = [];
            }
            this.loading = false;
        },
        async onSearchInput() {
            if (this.is_lazy) {
                this.searchLoading = true;
                await this.loadRows();
                this.searchLoading = false;
            } else {
                this.filters['global'].value = this.searchQuery;
            }
        },
        formatSlaHtml(value) {
            return value || '';
        },
        calculateTableOffset() {
            if (this.$refs.tableCard?.$el) {
                this.tableOffsetTop = this.$refs.tableCard.$el.getBoundingClientRect().top;
            }
            // Calcola dinamicamente l'altezza dell'header
            const header = document.querySelector('.header');
            if (header) {
                this.headerHeight = header.offsetHeight;
            }
        },
        // Metodo per applicare classi Tailwind tramite PrimeVue PT (PassThrough)
        getColumnPT(columnName, columnTitle = '') {
            // DEBUG: Log per verificare i nomi delle colonne
            console.log('Column name:', columnName);

            const widths = {
                'azioni': {width: '80px', minWidth: '80px', maxWidth: '80px' },
                'numero_ticket': { width: '100px', minWidth: '100px', maxWidth: '100px' },
                'priorita': { width: '72px', minWidth: '72px', maxWidth: '72px' },
                'titolo': { width: '200px', minWidth: '150px', maxWidth: '250px' },
                'last_thread': { width: '140px', minWidth: '130px', maxWidth: '150px' },
                'utente': { width: '140px', minWidth: '130px', maxWidth: '150px' },
                'assegnatari': { width: '140px', minWidth: '130px', maxWidth: '150px' },
                'tipo_ticket': { width: '140px', minWidth: '130px', maxWidth: '150px' },
                'sla': { width: '140px', minWidth: '130px', maxWidth: '150px' },
                'stato': { width: '140px', minWidth: '130px', maxWidth: '150px' },
            };

            const style = widths[columnName] || { minWidth: '80px' };

            return {
                headerCell: {
                    style,
                    class: `col-header-${columnName}`,
                    title: columnTitle // Tooltip che mostra il testo completo
                },
                bodyCell: {
                    style,
                    class: `col-body-${columnName}`
                }
            };
        },
        async loadThreadDrawer(data) {
            this.showDrawer = !this.showDrawer;
            this.loadticket = data.id;
        },
        retrieveFiltri() {
            return window.filtriDatatable('ticket')
        },
        async filtraAssegnatari(value, filter) {
            const filteredValue = this.filters.assegnatari.constraints[0].value;
            e.filteredValue = this.rows.filter((row) => {

                const assegnatari = row.assegnatari[0].props.assegnatari.map((a) => a.avatar.id);
                return assegnatari.includes(filteredValue);

            })

        },
        async filterTickets(tipo) {
            this.loading = true

            if (!this.filtrato || (this.filtrato && this.filtroScelto != tipo)) {
                this.filtrato = true
                this.filtroScelto = tipo

                // Rimuovi la classe active da tutti i filtri
                document.querySelectorAll('.filter-card').forEach(card => {
                    card.classList.remove('active');
                });

                // Aggiungi la classe active al filtro cliccato
                if (event && event.currentTarget) {
                    event.currentTarget.classList.add('active');
                }

                const righe = await axios.get(route(this.route_filtri, {tipo: tipo}));
                if (righe.status === 200) {
                    this.rows = righe.data;
                } else {
                    // Qui ci sarebbe da gestire l'errore se la chiamata non va a buon fine
                    this.rows = [];
                }
            } else {
                this.filtrato = false
                this.filtroScelto = null

                // Rimuovi la classe active da tutti i filtri
                document.querySelectorAll('.filter-card').forEach(card => {
                    card.classList.remove('active');
                });

                const righe = await axios.get(route(this.route_righe, this.buildRouteParams()));
                if (righe.status === 200) {
                    this.rows = righe.data.ticket;
                } else {
                    // Qui ci sarebbe da gestire l'errore se la chiamata non va a buon fine
                    this.rows = [];
                }
            }

            this.loading = false
        },
        async filterTicketsByCategoria() {
            this.loading = true
            this.filtrato = true
            this.filtroScelto = 'tipologia_tickets'
            if (this.filtro_categoria != 0) {

                const righe = await axios.get(route(this.route_filtri, {
                    tipo: this.filtroScelto,
                    categoria: this.filtro_categoria
                }));
                if (righe.status === 200) {
                    this.rows = righe.data;
                } else {
                    // Qui ci sarebbe da gestire l'errore se la chiamata non va a buon fine
                    this.rows = [];
                }
            } else {
                this.filtrato = false
                this.filtroScelto = null

                const righe = await axios.get(route(this.route_righe, this.buildRouteParams()));
                if (righe.status === 200) {
                    this.rows = righe.data.ticket;
                } else {
                    // Qui ci sarebbe da gestire l'errore se la chiamata non va a buon fine
                    this.rows = [];
                }
            }
            this.loading = false
        },
        onChangeSelect(e, k) {
            const selected_tipo = this.ticketingtipo_id;
            if (selected_tipo != 0) {

                axios.get(`/admin/ticketing/team/utenti/per-tipo/${selected_tipo}`).then((res) => {
                    if (res.data && res.data.length > 0) {
                        this.formStructure['ticketingutentiteam_id'][3] = [...res.data];
                    } else {
                        this.formStructure['ticketingutentiteam_id'][3] = [...this.allUser];
                    }
                }).catch((err) => {
                    console.log(err)
                })
            } else {
                this.formStructure['ticketingutentiteam_id'][3] = [...this.allUser];
            }
        },
        onSelectDipenedenteChange(event, key) {
            const firstSelected = event.value[0];
            if (firstSelected !== null && typeof firstSelected != "undefined") {

                axios.get(`/admin/ticketing/team/tipologie/per-utente/${firstSelected}`).then((res) => {
                    if (res.data && res.data.length > 0) {
                        this.formStructure['ticketingtipo_id'][3] = [...res.data];
                    } else {
                        this.formStructure['ticketingtipo_id'][3] = [...this.allTipi];
                    }
                }).catch((err) => {
                    console.log(err)
                })
            } else {
                this.formStructure['ticketingtipo_id'][3] = [...this.allTipi];
            }

        },
        onTableScroll(e) {
            const el = e.target;
            const threshold = 200;
            if (el.scrollTop + el.clientHeight >= el.scrollHeight - threshold) {
                this.loadMore();
            }
        },
        async loadMore() {
            if (this.loadingMore || this.allLoaded || !this.is_lazy) return;
            this.loadingMore = true;
            const nextPage = this.currentPage + 1;
            try {
                const righe = await axios.get(route(this.route_righe, this.buildRouteParams({
                    page: nextPage,
                    search: this.searchQuery || null,
                })));
                if (righe.status === 200) {
                    const nuovi = righe.data.ticket ?? righe.data;
                    if (!nuovi || nuovi.length === 0) {
                        this.allLoaded = true;
                    } else {
                        this.currentPage = nextPage;
                        this.rows = [...this.rows, ...nuovi];
                        if (this.rows.length >= this.total) {
                            this.allLoaded = true;
                        }
                    }
                }
            } catch (err) {
                console.error(err);
            }
            this.loadingMore = false;
        },
        async pageChange(e) {
            console.log(e)
            this.loading = true;
            if (this.is_lazy) {
                this.currentPage = e.page + 1;
                const righe = await axios.get(route(this.route_righe, this.buildRouteParams({
                    page: this.currentPage,
                    search: this.searchQuery || null,
                })));
                if (righe.status === 200) {
                    this.rows = righe.data.ticket ?? righe.data;
                    this.contatori = righe.data.contatori;
                    if (this.is_lazy) {
                        this.total = righe.data.total ?? this.total;
                        this.allLoaded = (this.rows?.length ?? 0) >= this.total;
                    }

                } else {
                    // Qui ci sarebbe da gestire l'errore se la chiamata non va a buon fine
                    this.rows = [];
                }
            }
            this.loading = false;
        },
        rowClicked(id) {

            //location.href = route(this.actions[0].url, {id: data.id})
            location.href = route(this.dettaglio, {id: id})
        },
        elimina_multiplo() {
            const data = {
                ids: [...this.selected]
            }
            axios.post(route('ticketing/elimina_multiplo'), data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                if (response.data.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$root.trans.success_form,
                        detail: this.$root.trans.salvataggio_success,
                        life: 3000
                    });
                    window.location.reload();
                } else {
                    if (response.data.message != null) {
                        this.$toast.add({
                            severity: 'errors',
                            summary: this.$root.trans.errors_form,
                            detail: this.$root.trans[response.data.message],
                            life: 5000
                        });
                    } else {
                        this.$toast.add({
                            severity: 'errors',
                            summary: this.$root.trans.errors_form,
                            detail: this.$root.trans.salvataggio_errato,
                            life: 3000
                        });
                    }
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        unisci_ticket() {
            console.log('unisco ticket')
            const data = {
                ticketing_id: [...this.selected]
            }
            axios.post(route(this.azione_unione), data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                if (response.data.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$root.trans.success_form,
                        detail: this.$root.trans.salvataggio_success,
                        life: 3000
                    });
                    window.location.reload();
                } else {
                    if (response.data.message != null) {
                        this.$toast.add({
                            severity: 'errors',
                            summary: this.$root.trans.errors_form,
                            detail: this.$root.trans[response.data.message],
                            life: 5000
                        });
                    } else {
                        this.$toast.add({
                            severity: 'errors',
                            summary: this.$root.trans.errors_form,
                            detail: this.$root.trans.salvataggio_errato,
                            life: 3000
                        });
                    }
                }
            }).catch((err) => {
                console.log(err)
            })
        },
        assegna_multiplo() {
            console.log(this.ticketingtipo_id, this.ticketingutentiteam_id, this.selected)
            const data = {
                ticketingtipo_id: this.ticketingtipo_id,
                ticketingutentiteam_id: this.ticketingutentiteam_id,
                ticketing_id: this.selected
            }
            axios.post(route(this.azione), data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                if (response.data.success) {
                    this.$toast.add({
                        severity: 'success',
                        summary: this.$root.trans.success_form,
                        detail: this.$root.trans.salvataggio_success,
                        life: 3000
                    });
                    window.location.reload();
                } else {
                    if (response.data.message != null) {
                        this.$toast.add({
                            severity: 'errors',
                            summary: this.$root.trans.errors_form,
                            detail: this.$root.trans[response.data.message],
                            life: 5000
                        });
                    } else {
                        this.$toast.add({
                            severity: 'errors',
                            summary: this.$root.trans.errors_form,
                            detail: this.$root.trans.salvataggio_errato,
                            life: 3000
                        });
                    }
                }
            }).catch((err) => {
                console.log(err)
            })

        },
        formatDate(value) {
            return new Date(value).toLocaleDateString('it-IT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },
        formatDateTime(value) {
            const date = new Date(value).toLocaleDateString('it-IT', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
            const time = new Date(value).toLocaleTimeString('it-IT', {
                hour: '2-digit',
                minute: '2-digit'
            });
            return date + "\n" + time;
        },
        formatTime(value) {
            const timeString = `1970-01-01T${value}`; // Adding a dummy date
            return new Date(timeString).toLocaleTimeString('it-IT', {
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        formatCurrency(value) {
            return value.toLocaleString('it-IT', {style: 'currency', currency: 'EUR'});
        },
        formatNumberInt(value) {
            return value.toLocaleString("it-IT", {minimumFractionDigits: 0, maximumFractionDigits: 0});
        },
        formatNumberDecimal(value) {
            return value.toLocaleString("it-IT", {minimumFractionDigits: 2, maximumFractionDigits: 2});
        },
        formatColor(value) {
            return '<i class="pi pi-circle-fill" style="color:' + value + '">';
        },
        formatSelectId(row, column) {
            return column.options.find((option) => option.id === (row[column.name] ?? 0)).nome;
        },
        clearFilter() {
            this.searchQuery = '';
            this.currentPage = 1;
            this.allLoaded = false;
            this.filters = {
                global: {value: null, matchMode: FilterMatchMode.CONTAINS},
            };
            this.initFilters();
        },
        initFilters() {
            // init custom filters first
            //this.filters['global'] = {value: null, matchMode: FilterMatchMode.CONTAINS};
            console.log('avvio i filtri')
            if (this.customFilters) {
                this.customFilters.forEach((filter) => {
                    this.filters[filter] = {
                        operator: FilterOperator.AND,
                        constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
                    }
                })
            }
            //this.filters['global'] = {value: null, matchMode: FilterMatchMode.CONTAINS};
            this.columns.forEach(column => {
                if (column.formato === 'data') {
                    this.filters[column.name] = {
                        operator: FilterOperator.AND,
                        constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
                    }
                } else if (column.formato === 'dataora') {
                    this.filters[column.name] = {
                        operator: FilterOperator.AND,
                        constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
                    }
                } else if (column.formato === 'ora') {
                    this.filters[column.name] = {
                        operator: FilterOperator.AND,
                        constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]
                    }
                } else if (column.formato === 'colore') {
                    this.filters[column.name] = {
                        operator: FilterOperator.AND,
                        constraints: [{value: null, matchMode: 'equals'}]
                    }
                } else if (column.formato === 'componenti') {
                    this.filters[column.name] = {
                        operator: FilterOperator.OR,
                        constraints: [{value: null, matchMode: 'componentFilter'}]
                    }
                } else {
                    this.filters[column.name] = {
                        operator: FilterOperator.AND,
                        constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
                    }
                }


            });
        },

        generateUrl(action, rowData) {

            const params = action.parametri.reduce((acc, param) => {
                acc[param] = rowData[param];
                return acc;
            }, {});

            return route(action.url, params);
        },
        component(name) {
            if (!name?.component) return null;
            const resolved = resolveComponent(name.component);
            return typeof resolved === 'string' ? null : (resolved ?? null);
        },
        componentProps(name) {
            const rawProps = toRaw(name.props ?? {});
            for (const [key, value] of Object.entries(rawProps?.functions ?? {})) {
                rawProps[key] = new Function(value);
            }
            return rawProps;
        },
        actionComponentProps(name) {
            const rawProps = toRaw(name ?? {});
            for (const [key, value] of Object.entries(rawProps?.functions ?? {})) {
                rawProps[key] = new Function(value);
            }
            return rawProps;
        },
        onRowEditSave: async function (event) {
            this.rows[this.rows.indexOf(event.data)] = event.newData;
            await axios.post(route(this.azioni['aggiorna'].url), event.newData);

        },
        rimuoviRiga: async function (action, elemento) {
            if (confirm(`${this.$root.trans.eliminare} ${elemento.nome ?? ` ${this.$root.trans.l_elemento_selezionato}`} ?`)) {
                const response = await axios.post(route(action.url, {id: elemento.id}),);
                if (response.status == 200) {
                    this.rows.splice(this.rows.indexOf(elemento), 1);
                    this.$toast.add({
                        severity: 'success',
                        summary: `${elemento.nome ?? this.$root.trans.elemento} ${this.$root.trans.eliminato}`,
                        detail: `${elemento.nome ?? this.$root.trans.elemento} ${this.$root.trans.eliminato} ${this.$root.trans.correttamente}`,
                        life: 3000
                    })
                } else {
                    this.$toast.add({
                        severity: 'error',
                        summary: `${response.status}`,
                        detail: `${this.$root.trans.elemento}: ${elemento.nome ?? this.$root.trans.elemento} `,
                        life: 3000
                    })
                }
            }
        },
    }
}

</script>


<style scoped>

</style>
